// extracted by mini-css-extract-plugin
module.exports = {"blankSpace":"Projects_blankSpace__qFSbo","filterList":"Projects_filterList__A1pRa","blink":"Projects_blink__kEuEF"};